import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { myConstants } from '../../shares/Constants'

export const UserApi = createApi({
  reducerPath: 'UserApi',
  tagTypes: ['Staff'],
  baseQuery: 
  fetchBaseQuery({
      baseUrl: myConstants.baseURL,
      prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.token;
        if (token) headers.set('Authorization', `token ${token}`);
        return headers;
      },
    }),
  endpoints: (build) => ({
    fetchStaff: 
    build.query({
        query: (year) => ({
          url: myConstants.endpoints.api.base + year + myConstants.endpoints.api.staff,
          method: 'GET',
        }),
        providesTags: (result, error, year) => [{ type: 'Staff', id: year }],
      }),
    }),
});

export const { useFetchStaffQuery } = UserApi;
